document.addEventListener('wpcf7mailsent', function(form) {
    const input = $(form.target).find('input[name="file"]');
    if (!input.length) {
        return;
    }
    const file = input.val();
    if (!file) {
        return;
    }
    fetch(file)
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = 'brochure.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        });
});
  